import { BRAND, getVariantData, track } from './shared';
import { centsAsDecimal } from '../utils/money';

const productProperties = ({ data, quantity }) => {
  const {
    purchaseType,
    productId,
    variantId,
    price
  } = getVariantData(data.variant_id);

  return ({
    // from variant data
    product_id: productId,
    variant_id: variantId,
    product_type: purchaseType,
    price: centsAsDecimal(price),
    quantity,
    // static
    currency: 'USD',
    brand: BRAND,
    products_added: 1,
    // from API response
    sku: data.sku,
    last_product_added: data.product_title,
    name: data.product_title,
    variant: data.variant_title,
    category: data.product_type
  });
};

const productAdded = (options) => {
  track({
    eventName: 's_track',
    data: {
      s_event: 'Product Added',
      s_properties: productProperties(options)
    }
  });
};

export default productAdded;
